
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/settings/profile/DAC7",
      function () {
        return require("private-next-pages/my/settings/profile/DAC7/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/settings/profile/DAC7"])
      });
    }
  